<template>
<div>
	<div class="fl-cabecalho">
		<div class="row animated slideInDown">
			<div class="col-12 form-group">
				<h4 class="animated slideInDown"><fa-icon icon="hdd" /> Equipamentos

					<fa-icon icon="angle-right"/> {{form.registro}} <label class="badge badge-primary">{{form.imei}}</label>

					<button @click="$emit('fechar')" class="btn btn-sm btn-outline-primary float-right">
						<fa-icon icon="arrow-left" /> <span v-if="!_isMobile"> Voltar </span>
					</button>
				</h4>
			</div>
		</div>
	</div>

    <hr />

    <div class="row">
        <div class="col-12 animated slideInDown col-md-12 col-xs-12 col-lg-7">
            <div class="btn-group form-group btn-block" :class="{'btn-group-sm' : _isMobile}">
                <button v-if="_getPrivilegio(8)" :class="{'active' : menu == 'C'}" @click="clickMenu('C')" type="button" class="btn btn-block text-center btn-outline-dark" style="margin-top: 0.5rem;" >
                    <fa-icon v-if="form.id != 0" icon="pen-alt"/><fa-icon v-if="form.id == 0" icon="plus"/>  <br v-if="_isMobile"/> Cadastro
                </button>
                <button :disabled="form.id == 0" :class="{'active' : menu == 'H'}" @click="clickMenu('H')" type="button" class="btn btn-block text-center btn-outline-dark"><fa-icon icon="history" /> <br v-if="_isMobile"/> Histórico</button>
                <button v-if="_getPrivilegio(11)" :disabled="form.id == 0" :class="{'active' : menu == 'S'}" @click="clickMenu('S')" type="button" class="btn btn-block text-center btn-outline-dark"><fa-icon icon="globe-americas" /> <br v-if="_isMobile"/> Servidores</button>
                <button v-if="_getPrivilegio(30)" :disabled="form.id == 0" :class="{'active' : menu == 'P'}" @click="clickMenu('P')" type="button" class="btn btn-block text-center btn-outline-dark"><fa-icon icon="map-marker-alt" /> <br v-if="_isMobile"/> Posições</button>
                <button v-if="_getPrivilegio(13)" :disabled="form.id == 0" :class="{'active' : menu == 'T'}" @click="clickMenu('T')" type="button" class="btn btn-block text-center btn-outline-dark"><fa-icon icon="route" /> <br v-if="_isMobile"/> Trechos</button>
            </div>
        </div>

        <div class="col-lg-12 col-md-12 col-xs-12 col-12">
            <div style="margin-top:0.8em">
                <flCadastro @item-salvo="itemSalvo" v-show="menu == 'C'" ref="cadastro" />
				<flHistorico ref="historico" v-show="menu == 'H'" />
                <flServidor v-show="menu == 'S'" ref="servidor" />
                <flReenvio v-if="menu == 'P'" ref="posicao" />
				<flTrecho ref="trecho" v-if="menu == 'T'" />
            </div>
        </div>
    </div>


</div>
</template>

<script>
import flCadastro from './cadastro.vue'
import flServidor from "./servidor.vue"
import flHistorico from "./historico.vue"
import flReenvio from "./posicao/main.vue"
import flTrecho from './trecho/main.vue'
export default {

    components: {
        flCadastro,
        flServidor,
        flHistorico,
        flReenvio,
        flTrecho,
    },

    data () {
        return {
            menu: 'C',
            form: {
                id: 0
            }
        }
    },

    methods: {
        editar(form){
            this.form = form
            this.clickMenu('C')

        },

        itemSalvo(form){
            this.form = form
            this.$emit('item-salvo', form)
        },

        clickMenu(menu){

            this.menu = menu

            if(menu == 'C'){
                this.$nextTick(() => this.$refs.cadastro.editar(this.form))
            }

            if(menu == 'H'){
                this.$nextTick(() => this.$refs.historico.editar(this.form))
            }

            if(menu == 'S'){
                this.$nextTick(() => this.$refs.servidor.editar(this.form))
            }

            if(menu == 'P'){
                this.$nextTick(() => this.$refs.posicao.carregaDados(this.form))
            }

            if(menu == 'T'){
                this.$nextTick(() => this.$refs.trecho.carregaDados(this.form))
            }

        },
    },
}
</script>




// WEBPACK FOOTER //
// src/views/equipamento/detalhe/main.vue